<template>
  <section>
    <h1 class="section-head">คำสั่งซื้อ {{ order.code }} - {{ order.company }}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-info" @click="refresh_pdf" v-if="order.ship_status == '1' || order.payment_status == '1' ? true : false"><i class="fas fa-sync-alt"></i></button>
            <button class="button is-success" @click="downloadReceipt" v-if="order.payment_status == '1' ? true : false"><i class="fas fa-download"></i>ดาวโหลดใบเสร็จ</button>
            <button class="button is-info" @click="download" v-if="order.ship_status == '1' ? true : false"><i class="fas fa-download"></i>ดาวโหลดใบส่งสินค้า</button>
            <router-link class="button is-warning" :to="'/order/edit/' + this.$route.params.id" v-if="order.ship_status == '1' || order.payment_status == '1' ? false : true" v-can="'edit_order'"
              ><i class="fas fa-pencil-alt"></i>แก้ไข</router-link
            >
            <!--<router-link class="button is-success" :to="('/purchaseorder/receive/'+this.$route.params.id)" v-if="order.status != 'received'"><i class="fas fa-box-open"></i>รับสินค้า</router-link>-->
          </div>
        </div>
      </div>
    </nav>

    <div class="margin-botton-10">
      <h1 class="section-sub-head">รายละเอียดคำสั่งซื้อจากลูกค้า</h1>
    </div>
    <div class="columns">
      <div class="column">
        <p><strong>Company:</strong> {{ order.company || '-' }}</p>
        <p><strong>Address:</strong> {{ order.address || '-' }}</p>
        <p><strong>Phone:</strong> {{ order.phone || '-' }}</p>
        <p><strong>Fax.:</strong> {{ order.fax || '-' }}</p>
        <p><strong>E-Mail:</strong> {{ order.email || '-' }}</p>
      </div>
      <div class="column">
        <p><strong>เลขคำสั่งซื้อ:</strong> {{ order.code || '-' }}</p>
        <p><strong>PO Number:</strong> {{ order.po_number || '-' }}</p>
        <p>
          <strong>สถานะการจัดส่ง:</strong>
          <b-switch v-can="'issue_tax_invoice'" :value="order.ship_status == '1' ? true : false" type="is-info" size="is-small" @click.native="updateStatus('shipment_status')"></b-switch>
          <a v-if="order.ship_status == '1' ? true : false" @click="download"> รหัส {{ order.ship_code }}</a>
        </p>
        <p>
          <strong>สถานะการชำระเงิน:</strong>
          <b-switch
            v-can="'issue_receipt'"
            :value="order.payment_status == '1' ? true : false"
            type="is-info"
            size="is-small"
            @click.native="updateStatus('payment_status')"
            v-if="order.payment_status == '0' ? true : false"
          ></b-switch>
          <span class="tag is-success" v-if="order.payment_status == '1' ? true : false">ชำระแล้ว</span>
          <a v-if="order.payment_status == '1' ? true : false" @click="downloadReceipt"> รหัส {{ order.payment_code }}</a>
        </p>
      </div>
    </div>

    <div>
      <b-table class="table-style" :data="order.items" :hoverable="true" :loading="isLoading" v-if="order.items || isLoading">
        <template slot-scope="props">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="250">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="sup_name" label="Supplier" width="200">
            {{ props.row.sup_name }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาขาย" width="100"> {{ parseFloat(props.row.price).formatMoney(2) }} บาท/{{ unitList[props.row.unit] }} </b-table-column>

          <b-table-column label="ส่วนลด(%)" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="ส่วนลด %" :value="props.row.discount + '%'" readonly />
              </p>
            </div>
          </b-table-column>

          <b-table-column label="ส่วนลด(฿)" width="60">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="ส่วนลด ฿" :value="props.row.discount_baht + ' บาท'" readonly />
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง" width="60">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static  is-small" type="text" placeholder="จำนวนสั่ง" :value="parseFloat(props.row.amount).formatMoney(2) + ' ' + unitList[props.row.unit]" readonly />
              </p>
            </div>
          </b-table-column>

          <b-table-column label="รวม" width="100">
            <input class="input is-static  is-small" type="text" placeholder="รวม" :value="parseFloat(props.row.total_price).formatMoney(2) + ' บาท'" readonly />
          </b-table-column>

          <b-table-column label="Remark" width="250">
            <input class="input is-static  is-small" type="text" placeholder="Remark" :value="props.row.remark" readonly />
          </b-table-column>
        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>
    </div>
  </section>
</template>

<script>
import Request from '@/libraries/request';
import OrderModel from '@/model/order_model';
import Const from '@/const/const';
import Config from '@/libraries/config';

export default {
  data() {
    return {
      order: [],
      unitList: Const.product_unit,
      isLoading: true,
      backPage: '/order',
      products: [],
      alert: {
        supplier: {
          type: '',
          msg: '',
        },
      },
      loadingClass: '',
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  methods: {
    async init() {
      try {
        if (this.$route.params.id) {
          const order = await OrderModel.get_order(this.$route.params.id);
          this.order = order[0];
        }
        this.isLoading = false;
      } catch (e) {
        this.$buefy.snackbar.open(e.message);
        this.$router.push('/order');
      }
    },
    updateStatus(which) {
      if (typeof which === 'undefined') {
        return;
      }
      let data = {};
      data.id = this.$route.params.id;
      if (which == 'shipment_status') {
        this.order.ship_status = this.order.ship_status == '1' ? '0' : '1';
        data.ship_status = this.order.ship_status;
        data.payment_status = this.order.payment_status;
        Request.post('order/update_shipment_status', data, res => {
          this.isLoading = false;
          this.loadingClass = '';
          if (res.data.status) {
            this.order = res.data.data;
            this.$buefy.snackbar.open('แก้ไขสถานะสำเร็จ!');
          }
        });
      }
      if (which == 'payment_status') {
        this.order.payment_status = this.order.payment_status == '1' ? '0' : '1';
        data.ship_status = this.order.ship_status;
        data.payment_status = this.order.payment_status;
        Request.post('order/update_status', data, res => {
          this.isLoading = false;
          this.loadingClass = '';
          if (res.data.status) {
            this.order = res.data.data;
            this.$buefy.snackbar.open('แก้ไขสถานะสำเร็จ!');
          }
        });
      }
    },
    download() {
      window.open(Config.baseUrl + '/' + this.order.ship_pdf_path);
    },
    downloadReceipt() {
      window.open(Config.baseUrl + '/' + this.order.receipt_pdf_path);
    },
    refresh_pdf() {
      this.isLoading = true;
      let data = {};
      data.id = this.$route.params.id;
      Request.post('order/refresh_pdf', data, res => {
        this.isLoading = false;
        this.loadingClass = '';
        if (res.data.status) {
          this.order = res.data.data;
          this.$buefy.snackbar.open('Refresh PDF สำเร็จ!');
        }
      });
    },
  },
};
</script>
<style scoped>
.table-style {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Order/view.vue